import { useState } from 'react'

import { ENTITY_LISTING_VIEW_TYPE } from '../../../../constants/common'
import { RequestProfileTabEmailsViewTypeContext } from '../RequestProfileTabEmails.contexts'

// Holds the emails table view (plain / with preview) for the lifetime of the
// opened request profile instead of the shared backend table config, so the
// preview toggle survives tab switches but never leaks into another request.
function RequestProfileTabEmailsViewTypeContextProvider({ children }) {
  const [listViewType, setListViewType] = useState(
    ENTITY_LISTING_VIEW_TYPE.table
  )

  const value = { listViewType, setListViewType }

  return (
    <RequestProfileTabEmailsViewTypeContext value={value}>
      {children}
    </RequestProfileTabEmailsViewTypeContext>
  )
}

export default RequestProfileTabEmailsViewTypeContextProvider
